import React, {MouseEventHandler, useEffect, useState} from "react";
import {launchConfetti} from "../utilities/confetti";
import {useAppSelector} from "src/store/store";
import TourButton from "../../TourButton/TourButton";
import Joyride, {STATUS} from "react-joyride"
import {IconClipboard} from "../../IconClipboard/IconClipboard";
import {DocumentationLink} from "../../ui/DocumentationLink";

const LicenseActivation = () => {
    const requestData = useAppSelector((state) => state.license.licenseData)
    const [copyState, setCopyState] = useState<boolean>(false);
    const [state, setState] = useState({
        run: false
    });
    const locale = {
        back: 'Geri',
        close: 'Kapat',
        last: 'Son',
        next: 'İleri',
        skip: "Atla"
    }
    const [isConfettiEffect, setIsConfettiEffect] = useState(false);
    useEffect(() => {
        if (!isConfettiEffect) {
            launchConfetti()
            setIsConfettiEffect(true);
        }
    }, [isConfettiEffect]);
    const startTour = () => {
        setState({run: true})
    }
    const handleJoyrideCallback = (data: any) => {
        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        if (finishedStatuses.includes(status)) {
            setState({run: false})
        }
    };
    const handleCopy: MouseEventHandler<HTMLButtonElement> = () => {
        if (typeof requestData === "string") {
            navigator.clipboard.writeText(requestData).then(
                function () {
                    setCopyState(true);
                    setTimeout(() => {
                        setCopyState(false)
                    }, 2000)
                },
                function (err) {
                    console.error("Async: Could not copy text: ", err);
                }
            );
        }
    };
    return (
        <div>
            <section className="py-14 max-w-screen-xl mx-auto">
                {state.run ?
                    <Joyride continuous callback={handleJoyrideCallback} run={state.run} steps={[
                        {
                            content: <h2>Lisans Aktivasyon rehberi için devam ediniz.</h2>,
                            placement: "center",
                            target: "body"
                        },
                        {
                            content: <h2>Buradaki boş alandaki kodu kopyalayıp HakedişPlus uygulamasında boş kısma
                                yapıştırabilirsiniz.</h2>,
                            placement: "bottom",
                            target: "#comment"
                        },
                        {
                            content: <h2>Buradaki ikona tıklayarak aktivasyon kodunu kolaylıkla
                                kopyalayabilirsiniz.</h2>,
                            placement: "bottom",
                            target: "#copyIcon"
                        }
                    ]} hideCloseButton
                             locale={locale}
                             scrollToFirstStep showSkipButton showProgress/> : ''}
                <div
                    className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-900 dark:shadow-gray-300 dark:border-gray-800 transition-colors duration-300">
                    <div className="relative z-10 max-w-xl mx-auto sm:text-center dark:border-gray-800">
                        <div className="space-y-3">
                            <h3 className="text-3xl font-bold">
                                Tebrikler!
                            </h3>
                            <p className=" leading-relaxed">
                                HakedişPlus çevrimdışı lisansınız aktifleştirildi. Aşağıdaki kodu
                                kopyalayıp HakedişPlus&apos;ta görünen ekranda boş alana yapıştırın.
                            </p>
                        </div>
                        <div
                            className="mt-6  items-center justify-center first:items-end rounded-lg p-1 dark:bg-gray-900 dark:border-gray-800">
                            <form onSubmit={e => e.preventDefault()}>

                                <div
                                    className="w-full border border-gray-200 rounded-lg dark:border-gray-600 dark:bg-gray-900">
                                    <div
                                        className="flex flex-col items-end px-3 py-2">
                                        <button
                                            id={"copyIcon"}
                                            className={`text-blue-500 hover:text-blue-600 duration-150 ${
                                                copyState ? "text-indigo-600 pointer-events-none" : ""
                                            }`}
                                            onClick={handleCopy}
                                        >
                                            <IconClipboard/>
                                            {copyState ? (
                                                <div
                                                    className='absolute top-28  px-2 py-1.5 rounded-xl bg-indigo-600 font-semibold text-white text-[10px] after:absolute after:inset-x-0 after:mx-auto after:top-[22px] after:w-2 after:h-2 after:bg-indigo-600 after:rotate-45'>
                                                    Kopyalandı
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </button>
                                    </div>
                                    <div className="px-4 py-2">

                                    <textarea id="comment"
                                              className="w-full h-32 px-0 text-gray-900 bg-white border-1 dark:bg-gray-900 dark:border-gray-800 dark:text-white transition-colors duration-300"
                                              placeholder="Aktivasyon kodu" required>{requestData}</textarea>
                                    </div>

                                </div>
                            </form>
                            <DocumentationLink/>
                        </div>
                    </div>
                </div>
            </section>
            <TourButton onClick={startTour}/>
        </div>
    )
}

export default LicenseActivation